import {Component, ContentChild, Input, TemplateRef, computed, signal, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PaginatorComponent} from '../paginator/paginator.component';

@Component({
  selector: 'app-paginated-list',
  standalone: true,
  imports: [CommonModule, PaginatorComponent],
  templateUrl: './paginated-list.component.html',
  styleUrl: './paginated-list.component.css',
})
export class PaginatedListComponent<T> implements OnChanges {
  @Input() items: T[] = [];
  @Input() pageSize: number = 6;
  @Input() colClass: string = 'col-12 col-md-4';
  @Input() trackBy?: (item: T) => unknown;

  @ContentChild(TemplateRef) itemTemplate!: TemplateRef<{ $implicit: T }>;

  currentPage = signal(0);
  itemsSignal = signal<T[]>([]);

  trackItem(item: T, index: number): unknown {
    if (this.trackBy) {
      return this.trackBy(item);
    }
    if (item === null || item === undefined) {
      return index;
    }
    if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
      return item;
    }
    const anyItem = item as Record<string, unknown>;
    const trackingKeys = ['id', 'username', 'userName', 'bggId', 'userId', 'organizationId', 'token'];
    for (const key of trackingKeys) {
      if (anyItem[key] !== null && anyItem[key] !== undefined) {
        return anyItem[key];
      }
    }
    return JSON.stringify(item) || index;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items']) {
      this.itemsSignal.set(changes['items'].currentValue || []);
      if (this.currentPage() >= this.totalPages() && this.totalPages() > 0) {
        this.currentPage.set(0);
      }
    }
  }

  totalPages = computed(() => Math.ceil(this.itemsSignal().length / this.pageSize));

  paginatedItems = computed(() => {
    const start = this.currentPage() * this.pageSize;
    const end = start + this.pageSize;
    return this.itemsSignal().slice(start, end);
  });

  onPageChange(page: number) {
    this.currentPage.set(page);
  }
}
